import { render, staticRenderFns } from "./StickyTable.vue?vue&type=template&id=59551fd4"
import script from "./StickyTable.vue?vue&type=script&lang=js"
export * from "./StickyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports